import clsx from "clsx"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { Layout } from "../../../ui/layout"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import Button from "../../../ui/molecules/button"
import { useEffect, useState } from "react"
import { Pagination } from "../../../ui/organisms/pagination"
import { Calendar } from "../../../ui/molecules/calendar"
import { SingleCheckbox } from "../../../ui/molecules/SingleCheckbox"
import { LogoSpinnerComponent } from "../../../lib/spinner/spinnerLogo"
import { GetAllM24Open, setGetAllFaseAvvioEndingDate, setGetAllM24OpenNorm, setGetAllM24OpenSot, setGetAllM24OpenStartingDate, setGetAllM24OpenType } from "./slice"
import { format } from "date-fns"
import { MonitoringM24OpenList } from "./list"
import { SelectCustom } from "../../../ui/molecules/select"
import { M024Type, normativa, sot } from "../../../utils"

export function MonitoringM24Open() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const m24OpenState = useAppSelector(state => state.m24Open)

    if (m24OpenState.getAllM24OpenStatus === 'loading') {
        return (
            <LogoSpinnerComponent fullScreen />
        )
    }

    return (
        <Layout menuItem={MenuItems.GESTIONE_CONTROLLO} breadcrumbItems={['Dashboard', 'Gestione Controllo', 'Monitoraggio Fase di Avvio']}
            noPaddingLat
            headerLabel="Monitoraggio M24 Aperti"
        >
            <div style={{ padding: '24px' }}>
                <div className="w-[100%] flex flex-col gap-[16px] filter" style={{ padding: '24px 0px 0px 0px' }}>
                    <div className="flex flex-row gap-[16px]" style={{ flex: 1, alignItems: 'center' }}>
                        <div style={{ justifyContent: 'left', flex: 1 }} className="flex gap-[16px] items-center">
                            <div style={{ flex: '0.33' }}>
                                <SelectCustom
                                    label="Tipo"
                                    placeholder={'Tipologia'}
                                    options={M024Type}
                                    onChange={(value) => dispatch(setGetAllM24OpenType(value))}
                                />
                            </div>
                            <div style={{ flex: '0.33' }}>
                                <SelectCustom
                                    placeholder={'Norma'}
                                    label="Norma"
                                    options={normativa}
                                    onChange={(value) => dispatch(setGetAllM24OpenNorm(value))}
                                />
                            </div>

                            <div style={{ flex: '0.33' }}>
                                <SelectCustom
                                    label="Sede"
                                    placeholder='Sede'
                                    options={sot}
                                    onChange={(value) => dispatch(setGetAllM24OpenSot(value))}
                                />
                            </div>

                            <div style={{ flex: '0.33' }}>
                                <Calendar
                                    label="Data Valutazione dal"
                                    //onClear={(date) => dispatch(setGetAllEPFilterFrom(date))}
                                    selected={m24OpenState.GetAllM24OpenFilters.from}
                                    onChange={(date) => dispatch(setGetAllM24OpenStartingDate(format(new Date(date), 'yyyy-MM-dd')))}
                                />
                            </div>
                            <div style={{ flex: '0.33' }}>
                                <Calendar
                                    label="Data Valutazione al"
                                    // onClear={(date) => dispatch(setGetAllEPFilterTo(date))}
                                    selected={m24OpenState.GetAllM24OpenFilters.to}
                                    onChange={(date) => dispatch(setGetAllFaseAvvioEndingDate(format(new Date(date), 'yyyy-MM-dd')))}
                                />
                            </div>
                            <div style={{ flex: '0.33' }}>
                                <SingleCheckbox
                                    name={'active'}
                                    checked={false}
                                    setChecked={(value) => {
                                        console.log('valore ', value)
                                    }}
                                    label='Nascondi Clienti con certificato emesso'
                                />
                            </div>
                            <div style={{ flex: '0.33', display: 'flex', alignItems: 'center' }}>
                                <span>
                                    <Button
                                        size={"lg"}
                                        iconPosition={"off"}
                                        variant={"outline"}
                                        label="Cerca"
                                        color={"blue"}
                                        onClick={
                                            () => {
                                                dispatch(GetAllM24Open(m24OpenState.GetAllM24OpenFilters))
                                            }
                                        }
                                    />
                                </span>
                            </div>
                        </div>
                        {/* <div style={{ display: 'flex', justifyContent: 'right', flex: 0.3 }}>
                            <Pagination
                                numbResults={m24OpenState.GetAllFaseAvvioResponse ? m24OpenState.GetAllFaseAvvioResponse.total : 0}
                                pages={m24OpenState.GetAllFaseAvvioResponse?.totalPage || 1}
                                currentPage={m24OpenState.GetAllM24OpenFilters.page ? m24OpenState.GetAllM24OpenFilters.page : 0}
                                detailsResults={'clienti'}
                                setPage={
                                    (page) => {
                                        dispatch(setGetAllM24OpenFiltersPage(page))
                                        dispatch(GetAllFaseAvvio(m24OpenState.GetAllM24OpenFilters))
                                    }
                                }
                            />
                        </div> */}
                    </div>
                </div>
                <MonitoringM24OpenList />
            </div>
        </Layout>
    )
}